export default __webpack_public_path__ + "static/bottom-683741d6e27c8a97bba0ff2aa359ee6d.png";